$(() => {
  const $slickElement = $('#property-photos-carousel');
  const $slidesCounter = $('#current-slide-number');

  const updateImageDimensions = (img) => {
    //get the index of the image from data-index attribute
    const imageIndex = img.getAttribute('data-index');
    const imageLink = $('#property-photos-carousel').find(
      `[data-pswp-photo-index="${imageIndex}"]`
    );
    if (!imageLink) return;
    if (img.naturalWidth && img.naturalHeight) {
      imageLink.attr('data-pswp-width', img.naturalWidth);
      imageLink.attr('data-pswp-height', img.naturalHeight);
    }
  };

  const checkSlideImages = () => {
    $slickElement.find('img').each(function () {
      if (this.complete && this.naturalWidth) {
        updateImageDimensions(this);
      } else {
        $(this).on('load', function () {
          updateImageDimensions(this);
        });
      }
    });
  };

  $slickElement.on('init reInit afterChange', function (
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    $slidesCounter.text((currentSlide ? currentSlide : 0) + 1);
    checkSlideImages();
  });

  $slickElement.slick({
    lazyLoad: 'anticipated',
    slidesToShow: 1,
    infinite: true,
    speed: 300,
    variableWidth: true,
    mobileFirst: true,
    nextArrow: $('#photos-carousel-next-arrow'),
    prevArrow: $('#photos-carousel-prev-arrow'),
  });

  const refresh = () => {
    $slickElement.slick('setPosition');
    $slickElement.slick('refresh');
  };

  $(window).on('resize', refresh);
  $slickElement.on('mapResized', refresh);
});
